import Loading from "../../components/Common/Loading";
import {useGetUserInfoV1CMQuery} from "../../core/api/clockmaker-analytical-data-api";
import UserSocialInfo from "./userSocialInfo";
import {useEffect, useState} from "react";


const UserSocialInfoCM = (props) => {

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUserInfoV1CMQuery(props.deviceId)
    const [infoData, setInfoData] = useState("");

    useEffect(() => {
        setInfoData(data)

    }, [data])

    return (
        <Loading
            isLoading={isLoading}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            {infoData && <UserSocialInfo
                data={infoData}

            />
            }
        </Loading>
    )
}

export default UserSocialInfoCM